import { chakra, Flex } from '@chakra-ui/react'
import React from 'react'

import { dangerousSVGs } from './SVGs'

export type DangerousGoodsCode = keyof typeof dangerousSVGs

interface GHSSymbolsProps {
  codes: string[]
}

export const GHSSymbols: React.FC<GHSSymbolsProps> = ({ codes }) => (
  <Flex flexWrap="wrap" m="-10px" mt="5px">
    {codes
      ? codes.map((code, index) => {
          if (dangerousSVGs.hasOwnProperty(code)) {
            const Component = chakra(dangerousSVGs[code as DangerousGoodsCode])
            return <Component key={index} m="10px" />
          }
        })
      : undefined}
  </Flex>
)
